import { useEffect } from 'react';

import Hero from '../../components/Hero/Hero';
import SobreMiInicio from '../../components/SobreMiInicio/SobreMiInicio';
import ServiciosInicio from '../../components/ServiciosInicio/ServiciosInicio';
import TestimoniosInicio from '../../components/TestimoniosInicio/TestimoniosInicio';
import Clientes from '../../components/Clientes/Clientes';
import ManualInicio from '../../components/Manual/ManualInicio';
import VolverArriba from '../../components/VolverArriba/VolverArriba';

import './Inicio.css';
import MiEstilo from '../../components/MiEstilo/MiEstilo';

function Inicio() {
  useEffect(() => {
    let saltando = false;

    const saltarHero = (event) => {
      const estamosEnHero =
        window.scrollY < window.innerHeight * 0.5;

      if (event.deltaY <= 0 || !estamosEnHero || saltando) {
        return;
      }

      const siguienteSeccion = document.getElementById(
        'sobre-mi-inicio'
      );

      if (!siguienteSeccion) {
        return;
      }

      event.preventDefault();
      saltando = true;

      siguienteSeccion.scrollIntoView({
        behavior: 'smooth',
      });

      setTimeout(() => {
        saltando = false;
      }, 800);
    };

    window.addEventListener('wheel', saltarHero, {
      passive: false,
    });

    return () => {
      window.removeEventListener('wheel', saltarHero);
    };
  }, []);

  return (
    <>
      <Hero />
      <SobreMiInicio />
      <MiEstilo />
      <ServiciosInicio />
      <TestimoniosInicio />
      <Clientes />
      <ManualInicio />
      <VolverArriba />
    </>
  );
}

export default Inicio;